export default __webpack_public_path__ + "static/media/logo_white_vetrical.def56830.png";